import { api } from "#web/services/api";
import { queryOptions } from "@tanstack/react-query";

export const VerifyThemeAppExtensionIsActiveQuery = ({ shopId }: { shopId: string | undefined }) =>
  queryOptions({
    enabled: !!shopId,
    queryFn: () => api.shopifyShop.verifyThemeAppExtensionIsActive(shopId!) as Promise<{ isActive: boolean }>,
    queryKey: ["verifyThemeAppExtensionIsActive", shopId],
  });
